'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { ENV } from '@/app/config/env';
import { loadPostHog } from '@/app/lib/posthog-client';

export function PostHogPageview() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname || !ENV.POSTHOG_KEY) return;

    const capturePageview = async () => {
      const posthog = await loadPostHog();
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + '?' + searchParams.toString();
      }
      posthog.capture('$pageview', { $current_url: url });
    };

    const browserWindow = window as typeof window & {
      requestIdleCallback?: (callback: IdleRequestCallback) => number;
      cancelIdleCallback?: (handle: number) => void;
    };

    if (browserWindow.requestIdleCallback && browserWindow.cancelIdleCallback) {
      const idleCallbackId = browserWindow.requestIdleCallback(() => {
        void capturePageview();
      });

      return () => browserWindow.cancelIdleCallback?.(idleCallbackId);
    }

    const timeoutId = browserWindow.setTimeout(() => {
      void capturePageview();
    }, 2000);

    return () => browserWindow.clearTimeout(timeoutId);
  }, [pathname, searchParams]);

  return null;
}
